// Server age plus the visible-tab refresh interval stays within the 60-second budget.
export const catalogCacheSeconds = 45;
export const catalogVisibleRefreshSeconds = 15;
export const catalogCacheMaxEntries = 256;
export const catalogRefreshEvent = "catalog:refresh";

// The HTTP cache may reuse a response only for the remainder of the same budget:
// 60 s - 45 s server TTL = 15 s. No stale-while-revalidate, because serving a stale
// copy while revalidating would push content past the 60-second bound.
export const catalogHttpCacheSeconds = 15;
